if (!window.__pcsHeadingFitInit) {
  window.__pcsHeadingFitInit = true;

  function fitPcsHeading(heading) {
    if (!heading) return;
    if (!heading.dataset.pcsBaseFontSize) {
      heading.dataset.pcsBaseFontSize = parseFloat(getComputedStyle(heading).fontSize);
    }
    var baseSize = parseFloat(heading.dataset.pcsBaseFontSize);
    var minSize = 14;
    var size = baseSize;
    heading.style.fontSize = size + "px";

    var guard = 0;
    while (heading.scrollWidth > heading.clientWidth && size > minSize && guard < 40) {
      size -= 0.5;
      heading.style.fontSize = size + "px";
      guard++;
    }
  }

  function fitAllPcsHeadings() {
    document.querySelectorAll(".pcs__heading").forEach(function (heading) {
      heading.style.fontSize = "";
      heading.dataset.pcsBaseFontSize = "";
      fitPcsHeading(heading);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fitAllPcsHeadings);
  } else {
    fitAllPcsHeadings();
  }
  window.addEventListener("load", fitAllPcsHeadings);

  var pcsResizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(pcsResizeTimer);
    pcsResizeTimer = setTimeout(fitAllPcsHeadings, 150);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAllPcsHeadings);
  }
}

if (!window.__pcsDropdownInit) {
window.__pcsDropdownInit = true;

function closePcsDropdowns() {
  document.querySelectorAll(".pcs__dropdown.is-open").forEach(function (dropdown) {
    dropdown.classList.remove("is-open");
    var toggle = dropdown.querySelector(".pcs__dropdown-toggle");
    if (toggle) toggle.setAttribute("aria-expanded", "false");
    var list = dropdown.querySelector(".pcs__dropdown-list") || dropdown.__pcsPortaledList;
    if (list) {
      list.hidden = true;
      if (list.__pcsDropdownOwner) {
        list.__pcsDropdownOwner.appendChild(list);
        list.__pcsDropdownOwner.__pcsPortaledList = null;
        list.__pcsDropdownOwner = null;
        list.classList.remove("collection-card-dropdown-portal");
        list.removeAttribute("style");
      }
    }
  });
}

document.addEventListener("click", function (e) {
  var toggle = e.target.closest(".pcs__dropdown-toggle");
  var option = e.target.closest(".pcs__dropdown-option");

  if (toggle) {
    var dropdown = toggle.closest(".pcs__dropdown");
    var isOpen = dropdown.classList.contains("is-open");
    closePcsDropdowns();
    if (!isOpen) {
      dropdown.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      var dropdownList = dropdown.querySelector(".pcs__dropdown-list");
      dropdownList.hidden = false;
      if (dropdown.closest(".collection-card-v2")) {
        var toggleRect = toggle.getBoundingClientRect();
        dropdown.__pcsPortaledList = dropdownList;
        dropdownList.__pcsDropdownOwner = dropdown;
        dropdownList.classList.add("collection-card-dropdown-portal");
        document.body.appendChild(dropdownList);
        dropdownList.style.position = "absolute";
        dropdownList.style.left = (toggleRect.left + window.scrollX) + "px";
        dropdownList.style.top = (toggleRect.bottom + window.scrollY + 4) + "px";
        dropdownList.style.width = toggleRect.width + "px";
        dropdownList.style.zIndex = "2147483647";
      }
    }
    return;
  }

  if (option) {
    var optionList = option.closest(".pcs__dropdown-list");
    var dropdown = option.closest(".pcs__dropdown") || (optionList && optionList.__pcsDropdownOwner);
    var variantId = option.getAttribute("data-variant-id");
    var value = option.getAttribute("data-value");
    if (variantId) {
      dropdown.querySelector(".pcs__dropdown-value").textContent = value;
      dropdown.querySelectorAll(".pcs__dropdown-option").forEach(function (li) {
        li.classList.remove("active");
        li.setAttribute("aria-selected", "false");
      });
      option.classList.add("active");
      option.setAttribute("aria-selected", "true");
      var card = dropdown.closest(".bls__product-item");
      if (card) {
        var addToCart = card.querySelector(".bls__product-addtocart-js");
        var button = card.querySelector(".pcs__add-btn");
        if (addToCart) {
          addToCart.setAttribute("data-product-variant-id", variantId);
        }
        if (button) {
          button.disabled = false;
        }

        var priceEl = card.querySelector(".pcs__price");
        var comparePriceEl = card.querySelector(".pcs__compare-price");
        var offEl = card.querySelector(".pcs__off");
        var priceText = option.getAttribute("data-price");
        var onSale = option.getAttribute("data-on-sale") === "true";
        if (priceEl && priceText) {
          priceEl.textContent = priceText;
        }
        if (comparePriceEl) {
          if (onSale) {
            comparePriceEl.textContent = option.getAttribute("data-compare-price");
            comparePriceEl.style.display = "";
          } else {
            comparePriceEl.style.display = "none";
          }
        }
        if (offEl) {
          if (onSale) {
            offEl.textContent = option.getAttribute("data-off");
            offEl.style.display = "";
          } else {
            offEl.style.display = "none";
          }
        }
      }
    }
    closePcsDropdowns();
    return;
  }

  if (!e.target.closest(".pcs__dropdown")) {
    closePcsDropdowns();
  }
});

}
